module.exports = __webpack_public_path__ + "media/img/illustrations/minus-7ac4a9f779db99373c928e1ad4ec340e.svg";